import React from 'react';
import { Modal, Image, Button } from 'react-bootstrap';
import SalirIcon from '../../../../Images/salir.svg'

export const ModalContact = (props) => {
  return(
    <Modal
      id="modal_reposition"
      size="lg"
      show={props.show}
      aria-labelledby="example-modal-sizes-title-sm"
    >
      <Modal.Header  style={{display: 'flex', flexDirection: 'column'}} className='custom-header-settings'>
        <div style={{width: '100%', display: 'flex', justifyContent: 'flex-end'}}>
          <Image src={SalirIcon} onClick={() => props.closeModal(false)} alt="X" style={{cursor: 'pointer'}}/>
        </div>
      </Modal.Header>
      <Modal.Body style={{padding: '10px 60px 50px'}}>
        <div style={{textAlign: 'center'}}>
          <span className='text-call-number'>{props.traductions.Card.enabled.modalCardReplacement.L_body}</span>
        </div>
        <div style={{textAlign: 'center', marginTop: '30px'}}>
          <span className='phone-number-blue'>+52 81 9034 9039</span>
        </div>
        <div style={{textAlign: 'center', marginTop: '30px'}}>
          <Button onClick={() => props.closeModal(false)} className='ghost-cancelar'>{props.traductions.Card.enabled.modalCardReplacement.L_cancel}</Button>
        </div>
      </Modal.Body>
    </Modal>
  )
}